import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const menuItems = [
    {
      label: 'Start a Business',
      type: 'mega',
      columns: [
        {
          header: 'Business Structures',
          items: [
            { name: 'Public Limited Company', path: '/public-limited', icon: 'fa-landmark' },
            { name: 'Private Limited Company', path: '/plc', icon: 'fa-city' },
            { name: 'One Person Company', path: '/opc', icon: 'fa-user-tie' },
            { name: 'Limited Liability Partnership', path: '/llp', icon: 'fa-building' },
            { name: 'Partnership Firm', path: '/partnership', icon: 'fa-user-group' },
            { name: 'Sole Proprietorship', path: '/proprietorship', icon: 'fa-user' },
          ]
        },
        {
          header: 'NGO & Special Entities',
          items: [
            { name: 'Section 8 Company', path: '/section-8', icon: 'fa-hands-helping' },
            { name: 'Trust Registration', path: '/trust', icon: 'fa-hand-holding-heart' },
            { name: 'Society Registration', path: '/society', icon: 'fa-users' },
            { name: 'Nidhi Company', path: '/nidhi-company', icon: 'fa-piggy-bank' },
            { name: 'Producer Company', path: '/producer-company', icon: 'fa-tractor' },
          ]
        }
      ]
    },
    {
      label: 'Tax & Compliance',
      type: 'mega',
      columns: [
        {
          header: 'GST Services',
          items: [
            { name: 'GST Registration', path: '/gst-registration', icon: 'fa-file-invoice' },
            { name: 'GST Return Filing', path: '/gst-filing', icon: 'fa-file-signature' },
            { name: 'GST LUT Form', path: '/lut-filing', icon: 'fa-globe' },
            { name: 'GST Amendment', path: '/gst-amendment', icon: 'fa-edit' },
            { name: 'GST Cancellation', path: '/gst-cancellation', icon: 'fa-ban' },
            { name: 'GST Notice Response', path: '/gst-notice', icon: 'fa-exclamation-triangle' },
          ]
        },
        {
          header: 'Income Tax',
          items: [
            { name: 'ITR Filing', path: '/itr-filing', icon: 'fa-file-invoice-dollar' },
            { name: 'Business Tax Filing', path: '/business-tax', icon: 'fa-briefcase' },
            { name: 'TAN Registration', path: '/tan-registration', icon: 'fa-id-card' },
            { name: 'TDS Return Filing', path: '/tds-return', icon: 'fa-percent' },
          ]
        },
        {
          header: 'Labour Compliance',
          items: [
            { name: 'EPF Registration', path: '/epf-registration', icon: 'fa-piggy-bank' },
            { name: 'ESI Registration', path: '/esi-registration', icon: 'fa-heartbeat' },
            { name: 'Professional Tax', path: '/professional-tax-reg', icon: 'fa-briefcase' },
            { name: 'Shops & Establishment', path: '/shops-establishment', icon: 'fa-store-alt' },
            { name: 'Labour License', path: '/labour-license', icon: 'fa-hard-hat' },
          ]
        }
      ]
    },
    {
      label: 'Licenses & Registrations',
      type: 'mega',
      columns: [
        {
          header: 'Government Registrations',
          items: [
            { name: 'Udyam Registration', path: '/udyam', icon: 'fa-industry' },
            { name: 'Startup India', path: '/startup-india', icon: 'fa-rocket' },
            { name: 'Digital Signature', path: '/digital-signature', icon: 'fa-key' },
            { name: 'Import Export Code', path: '/import-export', icon: 'fa-ship' },
            { name: 'ICEGATE Registration', path: '/icegate', icon: 'fa-door-open' },
          ]
        },
        {
          header: 'Industry Specific',
          items: [
            { name: 'Drug License', path: '/drug-license', icon: 'fa-pills' },
            { name: 'Fire License', path: '/fire-license', icon: 'fa-fire-extinguisher' },
            { name: 'Barcode Registration', path: '/barcode', icon: 'fa-barcode' },
            { name: 'BIS Registration', path: '/bis-registration', icon: 'fa-check-double' },
            { name: 'APEDA Registration', path: '/apeda', icon: 'fa-apple-alt' },
          ]
        }
      ]
    },
    {
      label: 'Trademark & IP',
      type: 'mega',
      columns: [
        {
          header: 'Trademark Services',
          items: [
            { name: 'Trademark Registration', path: '/trademark', icon: 'fa-registered' },
            { name: 'Trademark Search', path: '/trademark-search', icon: 'fa-search' },
            { name: 'Trademark Objection', path: '/trademark-objection', icon: 'fa-gavel' },
            { name: 'Trademark Renewal', path: '/trademark-renewal', icon: 'fa-sync' },
            { name: 'Trademark Assignment', path: '/trademark-assignment', icon: 'fa-exchange-alt' },
          ]
        },
        {
          header: 'Copyright & Patent',
          items: [
            { name: 'Copyright Registration', path: '/copyright', icon: 'fa-copyright' },
            { name: 'Patent Registration', path: '/patent', icon: 'fa-lightbulb' },
            { name: 'Patent Search', path: '/patent-search', icon: 'fa-search-plus' },
            { name: 'Design Registration', path: '/design-registration', icon: 'fa-palette' },
            { name: 'Logo Designing', path: '/logo-design', icon: 'fa-paint-brush' },
          ]
        }
      ]
    },
    {
      label: 'ISO & Certifications',
      type: 'mega',
      columns: [
        {
          header: 'ISO Standards',
          items: [
            { name: 'ISO 9001 (QMS)', path: '/iso-9001', icon: 'fa-check-circle' },
            { name: 'ISO 14001 (EMS)', path: '/iso-14001', icon: 'fa-leaf' },
            { name: 'ISO 45001 (OHS)', path: '/iso-45001', icon: 'fa-hard-hat' },
            { name: 'ISO 27001 (ISMS)', path: '/iso-27001', icon: 'fa-shield-alt' },
            { name: 'ISO 22000 (FSMS)', path: '/iso-22000', icon: 'fa-apple-alt' },
          ]
        },
        {
          header: 'Food & Trade Certs',
          items: [
            { name: 'FSSAI Registration', path: '/fssai', icon: 'fa-utensils' },
            { name: 'FSSAI License', path: '/fssai-license', icon: 'fa-id-badge' },
            { name: 'Halal Certificate', path: '/halal', icon: 'fa-certificate' },
            { name: 'Trade License', path: '/trade-license', icon: 'fa-store' },
            { name: 'RCMC Registration', path: '/rcmc', icon: 'fa-passport' },
          ]
        },
        {
          header: 'Product Certifications',
          items: [
            { name: 'CE Marking', path: '/ce-marking', icon: 'fa-globe-europe' },
            { name: 'RoHS Compliance', path: '/rohs', icon: 'fa-recycle' },
            { name: 'HACCP', path: '/haccp', icon: 'fa-clipboard-check' },
            { name: 'GMP', path: '/gmp', icon: 'fa-prescription-bottle' },
            { name: 'FSSC 22000', path: '/fssc-22000', icon: 'fa-award' },
          ]
        }
      ]
    },
    {
      label: 'MCA Compliance',
      type: 'mega',
      columns: [
        {
          header: 'Annual Compliance',
          items: [
            { name: 'Pvt Ltd Compliance', path: '/company-compliance', icon: 'fa-building' },
            { name: 'LLP Compliance', path: '/llp-compliance', icon: 'fa-handshake' },
            { name: 'OPC Compliance', path: '/opc-compliance', icon: 'fa-user-check' },
          ]
        },
        {
          header: 'Company Changes',
          items: [
            { name: 'Name Change', path: '/name-change', icon: 'fa-signature' },
            { name: 'Registered Office Change', path: '/office-change', icon: 'fa-map-marker-alt' },
            { name: 'Director Change', path: '/director-change', icon: 'fa-user-plus' },
            { name: 'Share Transfer', path: '/share-transfer', icon: 'fa-exchange-alt' },
          ]
        },
        {
          header: 'Filings & Closure',
          items: [
            { name: 'DIN eKYC', path: '/din-kyc', icon: 'fa-id-card' },
            { name: 'INC-20A Filing', path: '/inc-20a', icon: 'fa-file-alt' },
            { name: 'LLP Winding Up', path: '/llp-winding-up', icon: 'fa-times-circle' },
            { name: 'Company Winding Up', path: '/company-winding-up', icon: 'fa-power-off' },
          ]
        }
      ]
    }
  ];

  return (
    <>
      {/* Navbar */}
      <nav className={`${styles.navbar} ${isScrolled ? styles.scrolled : ''}`}>
        <div className="container">
          <div className={styles.navbarContent}>
            <Link to="/" className={styles.navbarLogo}>
              <img
                src="/img/newlogo.png"
                alt="India Dream Filings"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <span className={styles.brandName}>India Dream Filings</span>
            </Link>

            <button
              className={styles.mobileMenuToggle}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span className={isMobileMenuOpen ? styles.open : ''}></span>
              <span className={isMobileMenuOpen ? styles.open : ''}></span>
              <span className={isMobileMenuOpen ? styles.open : ''}></span>
            </button>

            <div className={`${styles.navbarMenu} ${isMobileMenuOpen ? styles.active : ''}`}>
              {menuItems.map((item, index) => (
                <div
                  key={index}
                  className={styles.navItem}
                  onMouseEnter={() => {
                    if (!isMobileMenuOpen) {
                      setActiveDropdown(index);
                      setActiveSubMenu(0); // Reset to first sub-category
                    }
                  }}
                  onMouseLeave={() => !isMobileMenuOpen && setActiveDropdown(null)}
                >
                  <button
                    className={styles.navLink}
                    onClick={() => isMobileMenuOpen && toggleDropdown(index)}
                  >
                    {item.label}
                    <i className="fas fa-chevron-down"></i>
                  </button>

                  {/* Mega Menu Dropdown */}
                  <div className={`${styles.dropdownMenu} ${activeDropdown === index ? styles.show : ''}`}>

                    {/* Side Drawer Logic */}
                    {item.columns ? (
                      <>
                        {/* Left Sidebar */}
                        <div className={styles.dropdownSidebar}>
                          {item.columns.map((column, colIndex) => (
                            <div
                              key={colIndex}
                              className={`${styles.sidebarItem} ${activeSubMenu === colIndex ? styles.active : ''}`}
                              onMouseEnter={() => setActiveSubMenu(colIndex)}
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent closing menu
                                setActiveSubMenu(colIndex);
                              }}
                            >
                              <span>{column.header}</span>
                              <i className="fas fa-chevron-right" style={{ fontSize: '10px', opacity: 0.5 }}></i>
                            </div>
                          ))}
                        </div>

                        {/* Right Content Area */}
                        <div className={styles.dropdownContentArea}>
                          {item.columns[activeSubMenu] && (
                            <>
                              <div className={styles.dropdownHeader}>{item.columns[activeSubMenu].header}</div>
                              <div className={styles.contentGrid}>
                                {item.columns[activeSubMenu].items.map((subItem, subIndex) => (
                                  <Link
                                    key={subIndex}
                                    to={subItem.path}
                                    className={styles.dropdownItem}
                                    onClick={() => setIsMobileMenuOpen(false)}
                                  >
                                    <i className={`fas ${subItem.icon || 'fa-circle'} fa-fw`}></i>
                                    {subItem.name}
                                  </Link>
                                ))}
                              </div>
                            </>
                          )}
                        </div>
                      </>
                    ) : (
                      /* Fallback for simple dropdowns */
                      <div className={styles.dropdownContentArea}>
                        <div className={styles.contentGrid}>
                          {item.items && item.items.map((subItem, subIndex) => (
                            <Link
                              key={subIndex}
                              to={subItem.path}
                              className={styles.dropdownItem}
                              onClick={() => setIsMobileMenuOpen(false)}
                            >
                              {subItem.name}
                            </Link>
                          ))}
                        </div>
                      </div>
                    )}

                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;

